import { render, staticRenderFns } from "./PartnerUserRolesFilter.vue?vue&type=template&id=59b244d0&"
import script from "./PartnerUserRolesFilter.vue?vue&type=script&lang=ts&"
export * from "./PartnerUserRolesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports